import type { TrpcRouter } from '@strength/trpc-server';
import {
  type CreateTRPCProxyClient,
  createTRPCProxyClient,
} from '@trpc/client';
import { getTrpcClientOptions } from './common';

export const getTrpcProxyClient = (
  onAuthError: () => void,
): CreateTRPCProxyClient<TrpcRouter> =>
  createTRPCProxyClient<TrpcRouter>(getTrpcClientOptions(onAuthError));

export type TrpcProxyClient = CreateTRPCProxyClient<TrpcRouter>;
